import { actions } from "utils/helpers";
import { toast } from "react-hot-toast";
import { UNAUTHORIZED } from "constants";
import Table from "components/Table/Table";
import { useDispatch, useSelector } from "react-redux";
import { selectAuthUser } from "features/auth/authSlice";
import { Fragment, useCallback, useEffect } from "react";
import Pagination from "components/Pagination/Pagination";
import { setNavbarTitle } from "features/navbar/navbarSlice";
import { useNavigate, useSearchParams } from "react-router-dom";
import TableSkeleton from "components/Table/TableSkeleton/TableSkeleton";
import {
  useGetConfigurationsQuery
} from "features/configuration/configurationApiSlice";

import cardStyles from "styles/modules/Card.module.scss";

const Configurations = ({ label }) => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const {
    currentData,
    isFetching: isLoading,
    isError,
    error
  } = useGetConfigurationsQuery(searchParams.toString());

  const dispatch = useDispatch();

  const authUser = useSelector(selectAuthUser);

  // const [deleteUser] = useDeleteConfigurationMutation();

  useEffect(() => {
    dispatch(setNavbarTitle("Configurations"));
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      toast.error(error || "Could not load configurations, try refreshing the page");
    }
  }, [isError, error]);

  // const onItemClickHandler = (id) => {
  //   navigate(`/configurations/${id}`);
  // };

  const onItemClickHandler = useCallback(
    (id, callFn = false) => {
      if (authUser?.actions[label].includes(actions.view)) {
        if (callFn) {
          navigate(`/configurations/${id}`);
        }
        return "";
      }
      return UNAUTHORIZED;
    },
    [authUser?.actions, label, navigate]
  );

  // const onEditBtnHandler = useCallback(
  //   (id, callFn = false) => {
  //     if (authUser?.actions[label].includes(actions.view)) {
  //       if (callFn) {
  //         navigate(`/configurations/${id}`);
  //       }

  //       return "";
  //     }

  //     return UNAUTHORIZED;
  //   },
  //   [authUser?.actions, label, navigate]
  // );

  // const onDeleteBtnHandler = useCallback(
  //   async (id, callFn = false) => {
  //     if (authUser?.actions[label].includes(actions.delete)) {
  //       if (callFn) {
  //         await deleteUser(id).unwrap();
  //       }

  //       return "";
  //     }

  //     return UNAUTHORIZED;
  //   },
  //   [authUser?.actions, deleteUser, label]
  // );

  return (
    <div>
      <div className={cardStyles.menu}>
        <h3>All Configurations</h3>
      </div>
      {isLoading ? (
        <TableSkeleton />
      ) : (
        <Fragment>
          <Table
            data={currentData}
            onItemClickHandler={onItemClickHandler}
          // onEdit={onEditBtnHandler}
          // onDelete={onDeleteBtnHandler}
          />
          <Pagination totalCount={currentData?.size} />
        </Fragment>
      )}
    </div>
  );
};

export default Configurations;
